
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PredictionsPage = lazy(() => import('../pages/predictions/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/predictions',
    element: <PredictionsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
